<template>
  <span :class="getClass" v-bind="$attrs">
    <MIcon prefix="g" icon="arrow-down" :size="size" />
  </span>
</template>
<script lang="ts" setup>
  import { computed } from 'vue';
  import { useDesign } from '@mts/hooks/web/useDesign';

  const props = defineProps({
    expand: { type: Boolean },
    up: { type: Boolean },
    down: { type: Boolean },
    left: { type: Boolean },
    size: { type: Number },
  });

  const { prefixCls } = useDesign('basic-arrow');

  // get component class
  const getClass = computed(() => {
    const { expand, up, down, left } = props;
    return [
      prefixCls,
      {
        [`${prefixCls}--active`]: expand,
        up,
        left,
        down,
      },
    ];
  });
</script>
<style lang="less" scoped>
  @prefix-cls: ~'@{namespace}-basic-arrow';

  .@{prefix-cls} {
    display: inline-block;
    transform: rotate(-90deg);
    transform-origin: center center;
    transition: all 0.3s ease 0.1s;
    cursor: pointer;

    &--active {
      transform: rotate(0deg);
    }

    &.left {
      transform: rotate(90deg);
    }

    &.up {
      transform: rotate(180deg);
    }

    &.down {
      transform: rotate(0deg);
    }

    &.up.@{prefix-cls}--active {
      transform: rotate(0deg);
    }

    &.down.@{prefix-cls}--active {
      transform: rotate(180deg);
    }
  }
</style>
